<template lang="pug">
.wrapper-approval-rules-details
  .titulo regra de aprovação
  .form-new
    .primeira-linha
      .nome
        Validate.name(v-model="nome")
          PTextField(
            name="name"
            label="nome da regra*"
          )
      //- .codigo
      //-   PTextField(
      //-     name="código"
      //-     label="código"
      //-     v-model="codigo"
      //-     v-mask="'######'"
      //-   )
      //- .texto-periodo
      //-   p período de vigência:&nbsp
      //-     span.direita.icon-ptt-icons-info.color-info.fs-15(:title="mensagemAjudaPeriodoVigencia")
      //- .inicio-periodo
      //-   PDatePicker(
      //-     name="dataInicioPeriodoVigencia"
      //-     label="início*"
      //-     v-model="dataInicioPeriodoVigencia"
      //-     format="DD.MM.YYYY"
      //-   )
      //- .fim-periodo
      //-   PDatePicker(
      //-     name="dataFimPeriodoVigencia"
      //-     label="fim*"
      //-     v-model="dataFimPeriodoVigencia"
      //-     format="DD.MM.YYYY"
      //-     :disabled="vigenciaSemFim"
      //-   )
      //- .checkbox-vigencia-sem-fim
      //-   PCheckbox(label="sem fim determinado" v-model="vigenciaSemFim")

    h3.subtitulo quais eventos geram um pedido segundo essa regra?

    .linha
      .quarenta-porcento
        PSelect(v-model="modelToCreate" name="modelToCreate" labelItem="name" :allowEmpty="false" title="tipo de evento*")

      .quando-evento-gerado
        PSelect(v-model="categoriasDisponiveis" name="categoria" labelItem="title" :allowEmpty="false" title="")

      .trinta-porcento(v-if="categories.selected")
        template(v-if="categories.selected.id !== 'roleGroup'")
          PMultiSelect(
            ref="itemSelector"
            labelItem="name"
            :title="categorieSelected.name"
            v-model="$data[categorieSelected.state]"
            :useCommon="categorieSelected.common"
            :disabled="!categories.selected"
            :permiteSelecionarTodos="true"
            usaPaginacao
            :limit="15"
          )
        template(v-else)
          PSelect(
            ref="itemSelector"
            labelItem="name"
            :title="categorieSelected.name"
            v-model="$data[categorieSelected.state]"
            :useCommon="categorieSelected.common"
            :disabled="!categories.selected"
            :allowEmpty="false"
          )

    .linha(v-if="modelToCreate.selected && modelToCreate.selected.name !== 'apontamento'")
      template(v-if="modelToCreate.selected.name === 'dispensa'")
        .quarenta-porcento
          PMultiSelect(
            labelItem="description"
            title="motivos"
            v-model="reasons"
            useCommon="reasons/onlyForJustify"
            :permiteSelecionarTodos="true"
          )
        PCheckboxTextField(
          v-model="bloqueioPedidos"
          labelPrimeiraParte="bloquear pedidos lançados mais de"
          :v-mask="'###'"
          labelSegundaParte="dias depois da data do evento"
          type="number"
        )
    .linha.fixada-inicio
      template(v-if="modelToCreate.selected && modelToCreate.selected.name === 'apontamento'")
        .trinta-e-cinco-porcento
          PSelect(
            labelItem="name"
            title="regra de cálculo*"
            v-model="customRules"
            useCommon="customRules"
          )
        .cinco-porcento.descricao-regra-calc
          p quando
        .custom-apontamento
          template(v-if="customRules.selected && apontamentos.length > 0")
            CustomApontamentos(useState="approvalsRules/details/limits" key="custom")
          template(v-else-if="carregandoNomeDosApontamentos")
            SkeletonBox(key="custom-apontamento" width="100%" height="40px" margin="15px 0 0 0")

    h3.subtitulo(v-if="modelToCreate.selected && modelToCreate.selected.name === 'dispensa'") quem pode responder ao pedido segundo essa regra?&nbsp
      span.direita.icon-ptt-icons-info.color-info.fs-15(:title="mensagemAjudaQuemPodeResponder")

    .linha
      PCheckbox(label="aprovar pedidos da regra automaticamente (poderá ser respondido com ciência do pedido)" v-model="autoApprove")
    .linha
      PCheckbox(
        v-if="modelToCreate.selected && modelToCreate.selected.name !== 'apontamento'"
        label="registrar e calcular eventos na folha antes da resposta (será deletado em caso de reprovação)"
        v-model="createFirst"
        :disabled="autoApprove"
      )

    .linha.perfis(v-if="exibirCampoPerfisAprovadores")
      .perfis__somente-rh
        PCheckbox(
          label="permitir somente aos usuários com permissão de RH responder os pedidos dessa regra",
          v-model="somenteRh"
        )
      .perfis__perfis-aprovadores
        PerfisAprovadores(
          v-model="perfisAprovadores"
          :listaPerfis="listaPerfis"
          :filtros="[perfil => !perfil.isRh]"
          unico
          :desativado="somenteRh"
          ref="perfisAprovadores"
        )

    .linha.data-de-fechamento(
      v-if="exibirCampoPerfisAprovadores"
      :class="{'data-de-fechamento--desativado': !exibirCampoDataFechamento}"
    )
      label(for="dataDeFechamento")
        | resetar o limite de respostas de todos os perfis a partir do dia
      Validate(v-model.number="diaDeFechamentoDasAprovacoes" :min="1" :max="31" onlyNumbers)
        PTextField(
          id="dataDeFechamento",
          label="",
          name="dataDeFechamento",
          v-mask="'##'",
          :disabled="!exibirCampoDataFechamento"
        )

    .linha.botoes
      .botao
        PButton(
          color="success"
          size="md"
          @click="salvar"
          :loading="carregandoSalvar"
          :disabled="carregandoNomeDosApontamentos"
          block
        ) salvar
      .botao
        PButton(
          color="danger"
          size="md"
          @click="cancelar"
          :disabled="carregandoSalvar || carregandoNomeDosApontamentos"
          block
        ) cancelar

  PModal(name="modalDeRegrasDeAprovacoesConflitantes" height="600px" width="600px")
    .modal-de-conflitos
      .modal-de-conflitos__icone
        img(src="../../../../static/images/erro_x.svg")
      .modal-de-conflitos__titulo
        h2 não foi possível salvar a regra
      .modal-de-conflitos__descricao
        p as configurações que você está tentando salvar contradizem as seguintes regras ativas:
      .modal-de-conflitos__lista
        .modal-de-conflitos__lista-item(
          v-for="(regraConflitante, index) in listaDeRegrasConflitantes"
          :key="index"
        )
          .modal-de-conflitos__lista-item-legenda
            div
              | {{ regraConflitante.name }}
          .modal-de-conflitos__lista-item-acao
            a(@click="abrirDetalhesDaRegraConflitante(regraConflitante)") ver detalhes

  PModal(v-if="regraConflitante" name="modalDeDetalhesDaRegraConflitante" height="540px" width="900px")
    .modal-detalhes-conflito
      .modal-detalhes-conflito__grid
        .modal-detalhes-conflito__grid-item.nome-da-regra
          .legenda
            | nome da regra
          .conteudo
            | {{ regraConflitante.name }}

        .modal-detalhes-conflito__grid-item.inicio-da-vigencia
          .legenda
            | início da vigência
          .conteudo
            | {{ regraConflitante.inicioDeVigencia }}

        .modal-detalhes-conflito__grid-item.fim-da-vigencia
          .legenda
            | fim da vigência
          .conteudo
            | {{ regraConflitante.fimDeVigencia }}

        .modal-detalhes-conflito__grid-item.status
          .legenda
            | status
          .conteudo
            | {{ regraConflitante.status }}

        .modal-detalhes-conflito__grid-item.tipo-do-evento
          .legenda
            | tipo do evento
          .conteudo
            | {{ regraConflitante.tipoDeEvento }}

        .modal-detalhes-conflito__grid-item.quando-gerado
          .legenda
            | quando é gerado
          .conteudo
            | {{ regraConflitante.quandoGerado }}

        .modal-detalhes-conflito__grid-item.empregados
          .legenda
            | empregados
          .conteudo
            PSelect(
              ref="itemSelector"
              labelItem="name"
              :title="categorieSelected.name"
              v-model="$data[categorieSelected.state]"
              :useCommon="categorieSelected.common"
              :disabled="!categories.selected"
              :allowEmpty="false"
            )

        .modal-detalhes-conflito__grid-item.regra-de-calculo
          .legenda
            | regra de cálculo
          .conteudo
            | {{ regraConflitante.regraDeCalculo }}

        .modal-detalhes-conflito__grid-item.eventos
          .legenda
            | eventos
          .conteudo
            div(v-for="(evento, eventoIndex) in regraConflitante.eventos" :key="eventoIndex")
              | {{ evento }}

        .modal-detalhes-conflito__grid-item.quem-responde
          .legenda
            | quem responde
          .conteudo
            div(v-for="(perfil, perfilIndex) in regraConflitante.quemResponde" :key="perfilIndex")
              | {{ perfil }}

        .modal-detalhes-conflito__grid-item.limite-mensal
          .legenda
            | limite mensal por usuário do perfil
          .conteudo
            div(v-for="(limite, limiteIndex) in regraConflitante.limiteMensalPorUsuarioDoPerfil" :key="limiteIndex")
              | {{ limite }}

      .modal-detalhes-conflito__acoes
        .modal-detalhes-conflito__acoes-botao-desativar
          PButton(color="warning", size="md", @click="cancel", :disabled="carregandoSalvar || carregandoInfo" block)
            | Desativar regra
        .modal-detalhes-conflito__acoes-botao-voltar
          PButton(color="danger", size="md", @click="cancel", :disabled="carregandoSalvar || carregandoInfo" block)
            | Voltar para a criação da regra
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapGetters, mapState } from 'vuex'
import { uniqueId, camelCase } from 'lodash'

import { useValidationsMixin } from 'src/common/validations'
import { floatToHoursMinsString, inputTimeTofloat, floatToHoursMins } from 'src/utils'
import RadioSlider from 'src/common/Tabs/RadioSlider'
import CustomApontamentos from '../components/CustomApontamentos'
import PerfisAprovadores from '../components/PerfisAprovadores'

export default {
  name: 'ApprovalsRulesDetails',
  props: {
    id: {type: String, default: null},
    modelToCreateDeEdicao: {type: String, default: null}
  },
  async created () {
    this.$store.dispatch('common/roleGroups/fetchItems')
    function pegaStringDoCompare (limite) {
      const temInicio = !['00:00', null].includes(limite.min)
      const temFim = !['00:00', null].includes(limite.max)

      if (temInicio && !temFim) return { id: 'min', name: 'maior ou igual a' }
      else if (!temInicio && temFim) return { id: 'max', name: 'menor ou igual a' }
      return { id: 'between', name: 'entre' }
    }

    function valorMinMax (limite) {
      const temInicio = !['00:00', null].includes(limite.min)
      const temFim = !['00:00', null].includes(limite.max)

      let min = !temInicio && temFim
        ? floatToHoursMins(inputTimeTofloat(limite.max))
        : floatToHoursMins(inputTimeTofloat(limite.min))
      let max = temInicio && temFim
        ? floatToHoursMins(inputTimeTofloat(limite.max))
        : { hours: 0, minutes: 0, float: 0.0 }

      return { min: min, max: max }
    }

    function capitalize (s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    }

    this.$store.commit('approvalsRules/details/resetState')

    if (this.id) {
      const resultado = await this.$API.approvalsRules.get({id: this.id})
      const regraDeAprovacao = resultado.body
      console.log(regraDeAprovacao)

      this.nome = regraDeAprovacao.name
      this.modelToCreate.selected = this.modelToCreate.loaded.find(i => i.id === regraDeAprovacao.modelToCreate)

      let categoriaSelecionadaId
      if (regraDeAprovacao.employees.length > 0) {
        categoriaSelecionadaId = 'employee'
        this.employees.selected = regraDeAprovacao.employees
      } else if (regraDeAprovacao.companys.length > 0) {
        categoriaSelecionadaId = 'company'
        this.companies.selected = regraDeAprovacao.companys
      } else if (regraDeAprovacao.groups.length > 0) {
        categoriaSelecionadaId = 'userGroup'
        this.userGroups.selected = regraDeAprovacao.groups
      } else if (regraDeAprovacao.perfis.length > 0) {
        categoriaSelecionadaId = 'roleGroup'
        this.roleGroups.selected = regraDeAprovacao.perfis[0]
      }

      this.categories.selected = this.categories.loaded.find(c => c.id === categoriaSelecionadaId)

      if (regraDeAprovacao.reasons) {
        this.reasons.selected = regraDeAprovacao.reasons.map(r => {
          return {id: r.id, description: r.name}
        })
      }

      this.bloqueioPedidos.check = regraDeAprovacao.limiteDeDiasPermitido > 0
      if (regraDeAprovacao.limiteDeDiasPermitido > 0) {
        this.bloqueioPedidos.limit = regraDeAprovacao.limiteDeDiasPermitido
      }

      this.autoApprove = regraDeAprovacao.autoApprove
      this.createFirst = regraDeAprovacao.createFirst
      this.diaDeFechamentoDasAprovacoes = regraDeAprovacao.diaDeFechamentoDasAprovacoes || 1
      this.perfisAprovadores = regraDeAprovacao.limiteAprovacoesMensalPorPerfil
      this.somenteRh = regraDeAprovacao.somenteRh

      if (regraDeAprovacao.customRules) this.customRules.selected = regraDeAprovacao.customRules

      if (regraDeAprovacao.limits) {
        await this.$store.dispatch(
          'approvalsRules/details/carregaNomeDosApontamentos',
          { idRegraDeCalculo: regraDeAprovacao.customRules.id }
        )

        const regraDeApontamentos = regraDeAprovacao.limits.map(limite => {
          const nomeDoApontamentoSelecionado = capitalize(camelCase(limite.name.replace('show', '')))

          return {
            id: uniqueId(),
            apontamento: this.apontamentos.find(a => a.id === nomeDoApontamentoSelecionado),
            comparacao: pegaStringDoCompare(limite),
            ...valorMinMax(limite)
          }
        })

        this.$store.commit('approvalsRules/details/limits', regraDeApontamentos)
      }
    } else {
      this.categories.selected = this.categories.loaded[3]
      this.modelToCreate.selected = this.modelToCreate.loaded[2]
    }
  },
  data () {
    return {
      somenteRh: false,
      listaDeRegrasConflitantes: [{
        id: 'teste',
        name: 'Verificação de Horas Noturnas - Fim de Ano'
      }],
      perfisAprovadores: [],
      regraConflitante: null,
      nome: '',
      // codigo: '',
      // dataInicioPeriodoVigencia: null,
      // dataFimPeriodoVigencia: null,
      // vigenciaSemFim: true,
      bloqueioPedidos: {check: false, limit: 30},
      diaDeFechamentoDasAprovacoes: 1,
      autoApprove: true,
      createFirst: true,
      reasons: { selected: [], selecionouTodos: false },
      customRules: { selected: null },
      companies: { selected: null, selecionouTodos: false },
      employees: { selected: null, selecionouTodos: false },
      userGroups: { selected: null, selecionouTodos: false },
      roleGroups: { selected: null, selecionouTodos: false },
      categories: {
        selected: null,
        loaded: [
          { name: this.$wp('company'), title: 'para os locais de trabalho', id: 'company', common: 'companies/onlyActive', state: 'companies' },
          { name: this.$wp('employee'), title: 'para os empregados', id: 'employee', common: 'employees/onlyNotFired', state: 'employees' },
          { name: 'grupos', title: 'para os grupos', id: 'userGroup', common: 'userGroups', state: 'userGroups' },
          { name: 'perfis de permissão', title: 'lançado pelo perfil', id: 'roleGroup', common: 'roleGroups/onlyNotRh', state: 'roleGroups' }
        ]
      },
      carregandoNomeDosApontamentos: false,
      carregandoSalvar: false,
      mensagemAjudaPeriodoVigencia: 'Periodo no qual as configurações da regra serão aplicadas. Ao editar uma regra, é possível definir uma nova data de início ' +
        'da vigência a partir da qual as alterações passarão a valer. Após o fim da vigência a regra ficará inativa.',
      mensagemAjudaQuemPodeResponder: 'Nesta seção é possível definir um ou mais perfis que poderão aprovar ou reprovar o pedido gerado, e definir  diferentes ' +
        'limites de resposta para cada perfil adicionado. Não é estabelecida hierarquia entre eles e o perfil de RH sempre poderá aprovar. ' +
        'O pedido será considerado respondido após ser aprovado ou reprovado por qualquer um dos perfis adicionados.',
      modelToCreate: {
        loaded: [
          {id: 'Line', name: 'apontamento'},
          {id: 'FakeTimeLog', name: 'correção manual'},
          {id: 'AbstractJustify', name: 'dispensa'}
          // {id: 'DayJourey', name: 'conversão de falta em bh'}
        ],
        selected: null
      }
    }
  },
  computed: {
    ...mapGetters('common/roleGroups', { listaPerfis: 'notRhNorEmployee' }),
    ...mapState('approvalsRules/details', ['apontamentos']),
    categorieSelected () {
      if (this.categories.selected) return this.categories.selected
      return { name: this.$wp('company'), title: 'para os locais de trabalho', id: 'company', common: 'companies/onlyActive', state: 'companies' }
    },
    exibirCampoPerfisAprovadores () {
      const {autoApprove, modelToCreate, listaPerfis} = this
      return !autoApprove && modelToCreate.selected && modelToCreate.selected.name === 'dispensa' && listaPerfis.length > 0
    },
    exibirCampoDataFechamento () {
      const {perfisAprovadores, somenteRh} = this
      const modeloPraCriarNaoEApontamento = this.modelToCreate.selected?.name !== 'apontamento'
      const algumLimiteDefinido = perfisAprovadores.some(perfil => perfil.limite_aprovacoes_mensal_por_perfil !== 0)
      return modeloPraCriarNaoEApontamento && algumLimiteDefinido && !somenteRh
    },
    categoriasDisponiveis: {
      get () {
        const {modelToCreate, categories} = this

        if (!modelToCreate.selected) {
          return categories
        }

        const tipoDeEventoDispensa = modelToCreate.selected.name === 'dispensa'
        if (tipoDeEventoDispensa) {
          return categories
        }
        const categoriasFiltradas = categories.loaded.filter(category => category.id !== 'roleGroup')
        return {
          selected: categories.selected,
          loaded: categoriasFiltradas
        }
      },
      set (categories) {
        this.categories.selected = categories.selected
      }
    }
  },
  methods: {
    async abrirDetalhesDaRegraConflitante ({ id }) {
      // quando tiver as opções no back esse mock pode sumir
      const mockRegraConflitante = {
        name: 'Verificação de Horas Noturnas - Fim de Ano',
        inicioDeVigencia: '01.10.2020',
        fimDeVigencia: '31.10.2020',
        status: 'Ativo',
        tipoDeEvento: 'apontamento',
        quandoGerado: 'para os empregados',
        valoresDaEntidade: [],
        regraDeCalculo: 'regra padrão',
        eventos: [
          'h.e noturna é maior ou igual a 2 horas',
          'h.e especial noturna é maior ou igual a 1 hora'
        ],
        quemResponde: [
          'gestor noturno A',
          'gestor noturno B',
          'gestor noturno C',
          'gestor noturno C'
        ],
        limiteMensalPorUsuarioDoPerfil: [
          '10',
          '30',
          'ilimitado',
          '40'
        ]
      }
      try {
        const resultado = await this.$API.consultarRegraConflitante.get({ id })
        const regraConflitante = resultado.data.success
        this.regraConflitante = regraConflitante || mockRegraConflitante
        this.$modal.show('modalDeDetalhesDaRegraConflitante')
      } catch (erro) {
        this.$modalDeErro(`Ocorreu um problema ao tentar pegar os detalhes da regra conflitante.`)
      }
    },
    async desativarRegraConflitante (regraConflitante) {
      try {
        const {id, name} = regraConflitante
        await this.$API.desativarRegraConclitante.save({
          id,
          active: false
        })
        this.$modalDeSucesso(`Regra ${name} desativada com sucesso.`)
      } catch (erro) {
        this.$modalDeErro(`Ocorreu um problema ao tentar desativar a regra ${name}.`)
      } finally {
        this.$modal.hide('modalDeDetalhesDaRegraConflitante')
      }
    },
    cancelar () {
      this.$store.commit('approvalsRules/details/resetState')
      this.$router.push('/approvals-rules/list')
    },
    formataRegraDeApontamentos (regraDeApontamentos) {
      if (!regraDeApontamentos) return []

      return regraDeApontamentos.map(item => {
        if (item.comparacao.id === 'between') {
          return {name: item.apontamento.id, min: floatToHoursMinsString(item.min.float), max: floatToHoursMinsString(item.max.float)}
        } else {
          return {name: item.apontamento.id, [item.comparacao.id]: floatToHoursMinsString(item.min.float)}
        }
      })
    },
    checaSeRegrasDeApontamentoSaoValidas (regraDeApontamentos) {
      return regraDeApontamentos
        .map(regra => regra.min.float > 0 && regra.min.float > 0)
        .every(ehValido => ehValido === true)
    },
    async carregaNomeDosApontamentos (idRegraDeCalculo) {
      this.carregandoNomeDosApontamentos = true

      try {
        await this.$store.dispatch('approvalsRules/details/carregaNomeDosApontamentos', { idRegraDeCalculo })
      } catch (e) {
        console.error(e)
      } finally {
        this.carregandoNomeDosApontamentos = false
      }
    },
    async salvar () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }

      const name = this.nome
      const somenteRh = this.somenteRh
      const companys = this.companies.selected || []
      const employees = this.employees.selected || []
      const groups = this.userGroups.selected || []
      const perfis = this.roleGroups.selected ? [this.roleGroups.selected] : []

      if (companys.length === 0 && employees.length === 0 && groups.length === 0 && perfis.length === 0) {
        this.$modalDeErro(`Selecione os ${this.$ws('company')}/${this.$ws('employee')}/${this.$ws('group')}/perfis que geram esse evento`)
        return
      }

      this.carregandoSalvar = true

      const data = {
        name,
        companys,
        employees,
        groups,
        perfis,
        somenteRh,
        modelToCreate: this.modelToCreate.selected.id,
        autoApprove: this.autoApprove,
        createFirst: this.autoApprove === true ? true : this.createFirst,
        limiteAprovacoesMensalPorPerfil: this.autoApprove ? [] : this.perfisAprovadores
      }

      if (this.id) data.id = this.id

      if (data.modelToCreate === 'AbstractJustify') {
        if (this.reasons.selected.length === 0) {
          this.$modalDeErro('Selecione pelo menos um motivo de dispensa')
          this.carregandoSalvar = false
          return
        }
        data.reasons = this.reasons.selected

        if (this.bloqueioPedidos.check && (!this.bloqueioPedidos.limit || Number(this.bloqueioPedidos.limit) === 0)) {
          this.$modalDeErro('Por favor determine quantos dias após o evento o lançamento deverá ser bloqueado')
          this.carregandoSalvar = false
          return
        }
        if (this.bloqueioPedidos.check) data.limiteDeDiasPermitido = Number.parseInt(this.bloqueioPedidos.limit)
        if (this.exibirCampoDataFechamento) {
          data.diaDeFechamentoDasAprovacoes = Number.parseInt(this.diaDeFechamentoDasAprovacoes)
        }
        // data.all_elements = this.reasons.selecionouTodos - TODO - junto com modificação no PMultiSelect

        // data.all_elements = this.reasons.selecionouTodos - TODO - junto com modificação no PMultiSelect
        const naoEhAutoAprovacao = !this.autoApprove

        const perfisNaoValidos = naoEhAutoAprovacao && !somenteRh && !this.$refs.perfisAprovadores.todosOsAprovadoresSaoValidos
        if (perfisNaoValidos) {
          this.$modalDeErro('Por favor determine quantos pedidos poderão ser respondidos pelo(s) perfil(s) de aprovador selecionado')
          this.carregandoSalvar = false
          return
        }
      } else if (data.modelToCreate === 'Line') {
        if (!this.customRules.selected) {
          this.$modalDeErro('Selecione pelo menos um regra de cálculo')
          this.carregandoSalvar = false
          return
        } else {
          const regraDeApontamentos = this.$store.state.approvalsRules.details.limits

          const regraDeApontamentosSaoValidas = this.checaSeRegrasDeApontamentoSaoValidas(regraDeApontamentos)
          if (!regraDeApontamentosSaoValidas) {
            this.$modalDeErro('Não é possível salvar apontamentos com valor de horas 0')
            this.carregandoSalvar = false
            return
          }

          data.customRules = this.customRules.selected.id
          data.limits = this.formataRegraDeApontamentos(regraDeApontamentos)
        }
      }

      try {
        let resultado
        if (data.modelToCreate === 'Line') {
          resultado = await this.$API.lineApprovalRules.save(data)
        } else {
          resultado = await this.$API.objectsApprovalRules.save(data)
        }

        this.$modalDeSucesso(resultado.body.created ? resultado.body.created : resultado.body.success || 'Regra criada/editada com sucesso!')

        this.$store.commit('approvalsRules/details/resetState')
        this.$router.push('/approvals-rules/list')
      } catch (e) {
        console.error(e)
        if (e?.data?.id) {
          const {id, error} = e.data
          this.listaDeRegrasConflitantes = [{
            id,
            name: error
          }]
          this.$modal.show('modalDeRegrasDeAprovacoesConflitantes')
        } else {
          const msgDeErroComum = 'Não foi possível criar a regra. ' +
            'Por favor, tente novamente. ' +
            'Se o erro persistir entre em contato com o suporte.'
          this.$modalDeErro(e?.data?.error ? e.data.error : msgDeErroComum)
        }
      } finally {
        this.carregandoSalvar = false
      }
    }
  },
  watch: {
    'customRules.selected': async function () {
      this.$store.commit('approvalsRules/details/resetState')
      if (this.customRules.selected) {
        await this.carregaNomeDosApontamentos(this.customRules.selected.id)
      }
    },
    'modelToCreate.selected': async function (newValue) {
      if (newValue.id !== 'AbstractJustify' && this.categories.selected.id === 'roleGroup') {
        this.categories.selected = this.categories.loaded[0]
      }
    }
  },
  directives: { mask },
  mixins: [useValidationsMixin({})],
  components: { RadioSlider, CustomApontamentos, PerfisAprovadores }
}
</script>

<style scoped lang="scss">
.wrapper-approval-rules-details {
  width: 100%;
  box-sizing: border-box;

  font-family: 'Rubik';
  font-style: normal;

  .titulo {
    font-weight: bold;
    font-size: 25px;
    line-height: 2vh;
    text-align: center;
    justify-items: center;
    margin: 20px 0px;
  }

  .form-new {
    align-items: center;
    justify-content: center;

    .primeira-linha {
      display: grid;
      grid-template-columns: 1fr 70px 170px 150px 150px 160px;
      column-gap: 15px;

      .checkbox-vigencia-sem-fim {
        align-self: center;
      }
    }

    .linha {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      align-items: center;
    }

    .linha.fixada-inicio {
      align-items: flex-start;
    }

    .descricao-regra-calc {
      padding-top: 0.5%;
    }

    .cinco-porcento {
      width: 5%;
      box-sizing: border-box;
      padding-right: 2%;
    }

    .sete-porcento {
      width: 7%;
      box-sizing: border-box;
      padding-right: 2%;
    }

    .dez-porcento {
      width: 10%;
      box-sizing: border-box;
      padding-right: 2%;
    }

    .datas {
      width: 12%;
      padding-left: 1%;
      padding-right: 1%;
      margin-right: 1%;
      margin-left: 2%;
      box-sizing: border-box;
    }

    .quinze-porcento {
      width: 15%;
      padding-right: 2%;
      box-sizing: border-box;
    }

    .quando-evento-gerado {
      width: 18%;
      padding-right: 1.5%;
      box-sizing: border-box;
    }

    .vinte-porcento {
      width: 20%;
      padding-right: 2%;
      box-sizing: border-box;
    }

    .vinte-e-cinco-porcento {
      width: 20%;
      padding-right: 2%;
      box-sizing: border-box;
    }

    .trinta-porcento {
      width: 30%;
      box-sizing: border-box;
      padding-right: 2%;
    }

    .trinta-e-cinco-porcento {
      width: 33%;
      box-sizing: border-box;
      padding-right: 2%;
    }

    .quarenta-porcento {
      width: 40%;
      box-sizing: border-box;
      padding-right: 2%;
    }

    h3.subtitulo {
      width: 100%;
      margin-bottom: 2%;
    }

    .custom-apontamento {
      flex: auto;
      width: 60%;
      box-sizing: border-box;
      padding-left: 2%;
    }

    .dia-de-fechamento-das-aprovacoes {
      margin-left: 3px;
      width: 130px;
    }

    .linha.botoes {
      justify-content: flex-end;
    }

    .linha.perfis {
      margin-top: 2%;
    }

    .botao {
      margin-left: 1px;
      margin-top: 5%;
    }
  }

  .data-de-fechamento--desativado {
    opacity: .4;
  }

  .linha.data-de-fechamento {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    label {
      margin-right: 1rem
    }

    div {
      width: 4rem
    }
  }

  .modal-de-conflitos {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    height: 100%;

    * {
      box-sizing: border-box;
    }

    &__icone {}

    &__titulo {
      color: #FF6854;
    }
    &__descricao {
      text-align: center;
    }
    &__lista {
      max-height: 200px;
      overflow-y: auto;
      width: 100%;
      padding: 1rem;
      border: thin solid lightgray;

      &-item {
        display: grid;
        grid-template-areas: "legenda acao";
        grid-template-columns: .75fr .25fr;
        grid-template-rows: auto;
        margin-bottom: 2rem;

        &:not(:first-child) {
          margin-top: 2rem;
        }
      }
      &-legenda {
        grid-area: legenda;
      }
      &-acao {
        grid-area: acao;

        a {
          text-decoration: underline!important;
          color: #00A2B5;
        }
      }
    }
  }

  .modal-detalhes-conflito__acoes {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-flow: row nowrap;
    * {
      margin-left: 1px;
    }
  }

  .modal-detalhes-conflito__grid {
    display: grid;
    grid-template-areas:
      "nome_da_regra nome_da_regra nome_da_regra"
      "inicio_vigencia fim_vigencia status"
      "tipo_do_evento quando_gerado empregados"
      "regra_de_calculo eventos eventos"
      "quem_responde limite_mensal limite_mensal";
    grid-template-columns: .20fr .20fr auto;
    grid-template-rows: auto auto auto auto auto;
    grid-gap: 2rem;

    &-item {
      .legenda {
          font-size: .8em;
          font-weight: bold;
          &:after {
            content: ":"
          }
      }

      .conteudo {
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        flex-flow: column nowrap;
      }

      &.nome-da-regra {
        grid-area: nome_da_regra;
      }
      &.inicio-da-vigencia {
        grid-area: inicio_vigencia;
      }
      &.fim-da-vigencia {
        grid-area: fim_vigencia;
      }
      &.status {
        grid-area: status;
      }
      &.tipo-do-evento {
        grid-area: tipo_do_evento;
      }
      &.quando-gerado {
        grid-area: quando_gerado;
      }
      &.empregados {
        grid-area: empregados;
      }
      &.regra-de-calculo {
        grid-area: regra_de_calculo;
      }
      &.eventos {
        grid-area: eventos;
      }
      &.quem-responde {
        grid-area: quem_responde;
      }
      &.limite-mensal {
        grid-area: limite_mensal;
      }
    }
  }
}
</style>
